import { MatDialogRef } from "@angular/material/dialog";


export abstract class DialogWrapper<T = any, Data = any, Return = any> {
  public abstract dialogRef: MatDialogRef<T, Return>;
  public abstract matDialogData: Data;
  constructor() { }

  open = true

  onClosed() {
    this.dialogRef.close();
  }

  close = () => {
    this.dialogRef.close();
  }
}
